export enum ScoreTypes {
  ATTITUDINAL = 'attitudinal',
  SUBJECT = 'subject',
}
